/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6daf4474"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card-title flex justify-between align-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "包名、参数配置", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "游戏包名", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, "· 注意填入包名需与渠道后台一致，否则包体无法登陆"), /*#__PURE__*/_createElementVNode("li", null, "· 包名一般为com.xxxx.xx的形式，可用字母及数字组合，但数字不能放在.后第一位"), /*#__PURE__*/_createElementVNode("li", null, "· 只能包含大小写英文字母、数字、下划线、句点（.）"), /*#__PURE__*/_createElementVNode("li", null, "· 以句点分割称为“段”，必须至少包含2个段，且不能有空段（即不能以句点开头或者结尾）"), /*#__PURE__*/_createElementVNode("li", null, "· 每个段必须以英文字母开头，不能以数字或下划线开头")], -1));
import ChannelParams from './channelParams.vue';
import { UseComProps } from './hooks';
import { apiUsdkSetPackage, apiUsdkSetParamConf } from '@/api/usdk';
import SaveBtn from './saveBtn.vue';
import Sign from './sign.vue';
import TipsModal from '../tipsModal.vue';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  props: {
    ...UseComProps()
  },
  setup(__props) {
    const props = __props;
    const tipsModalRef = ref();
    const form = ref({
      packageName: props.channel.packageName
    });
    const oldForm = ref({
      packageName: props.channel.packageName
    });
    const deepPackageName = ref(props.channel.packageName);
    const isEdit = ref(false);
    const operateType = ref('cancel');
    const handleClick = type => {
      operateType.value = type;
      if (type === 'edit') {
        isEdit.value = true;
      } else if (type === 'cancel') {
        isEdit.value = false;
        form.value.packageName = deepPackageName.value;
      } else {
        handleSave();
      }
    };
    // const handleOk = () => {
    // 	operateType.value = 'cancel';
    // 	isEdit.value = false;
    // };
    const btnLoading = ref(false);
    const serverParams = ref();
    const handleConfirm = async type => {
      console.log('type===', type);
      operateType.value = type;
      let params = {};
      params.id = props.channel.id;
      params.package = form.value.packageName;
      params.gid = props.gid;
      params.cid = props.channel.cid;
      btnLoading.value = true;
      await apiUsdkSetPackage(params);
      await apiUsdkSetParamConf(serverParams.value);
      operateType.value = 'cancel';
      btnLoading.value = false;
      isEdit.value = false;
      tipsModalRef.value.closeModal(); // 我已知晓风险并确认修改无误
      const dict1 = {
        packageName: {
          name: '包名'
        }
      };
      console.log('form.value', form.value);
      customDataReport({
        eventName: 'set_package_name_and_params_conf',
        dict: dict1,
        before: oldForm.value,
        after: form.value,
        operatePath: '出包-渠道配置-基础配置-包名、参数配置',
        gid: props.gid
      });
      oldForm.value = JSON.parse(JSON.stringify(form.value));
      customDataReport({
        eventName: 'set_sdk_params_conf',
        dict: sdkParamsDict.value,
        before: sdkParamsOldData.value,
        after: sdkParamsNewData.value,
        operatePath: '出包-渠道配置-基础配置-包名、参数配置',
        gid: props.gid
      });
    };
    const handleSave = () => {
      if (props.channel.plat == 2) return;
      const pkgReg = /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/gi;
      if (!pkgReg.test(form.value.packageName) && props.channel.plat != 2) {
        ElMessage.warning('包名不符合, 请示输入com.xxx.xxx的形式，可用字母及数字组合');
      }
      // tipsModalRef.value.showModal();
    };
    const editArr = ref([]);
    // 上报的数据
    const sdkParamsNewData = ref();
    const sdkParamsOldData = ref();
    const sdkParamsDict = ref();
    // 处理渠道参数
    const handleChannelParam = (params, arr, dict, newData, oldData) => {
      sdkParamsNewData.value = newData;
      sdkParamsOldData.value = oldData;
      sdkParamsDict.value = dict;
      editArr.value = arr;
      serverParams.value = params;
      let editParams = '';
      const pkgReg = /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/gi;
      if (!pkgReg.test(form.value.packageName) && props.channel.plat != 2) {
        ElMessage.warning('包名不符合, 请示输入com.xxx.xxx的形式，可用字母及数字组合');
        return;
      }
      if (deepPackageName.value !== form.value.packageName && deepPackageName.value) {
        editArr.value.unshift('包名');
      }
      if (arr.length > 0) {
        const length = arr.length;
        if (length > 5) {
          editParams = editArr.value.slice(0, 5).join(',') + '等' + length + '项';
        } else {
          editParams = editArr.value.join(',');
        }
        tipsModalRef.value.showModal({
          editParams
        });
      } else {
        handleConfirm('save');
      }
    };
    const handleCancel = () => {
      operateType.value = 'cancel';
      isEdit.value = false;
      form.value.packageName = deepPackageName.value;
    };
    return (_ctx, _cache) => {
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, !isEdit.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "btn-color cp",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('edit'))
      }, "[编辑]")) : (_openBlock(), _createBlock(SaveBtn, {
        key: 1,
        loading: btnLoading.value,
        onCancel: handleClick,
        onSave: handleClick
      }, null, 8, ["loading"]))]), _ctx.channel.plat != 2 ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        model: form.value,
        class: "u-form marginT20",
        "label-position": "top",
        style: {
          "width": "668px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          rules: [{
            required: true,
            message: '请输入包名',
            trigger: 'change'
          }],
          prop: "packageName"
        }, {
          label: _withCtx(() => [_hoisted_3, _createVNode(_component_u_question, null, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.packageName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.packageName = $event),
            disabled: !isEdit.value
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])) : _createCommentVNode("", true), _createVNode(ChannelParams, {
        channel: _ctx.channel,
        gid: _ctx.gid,
        operateType: operateType.value,
        onOk: handleChannelParam
      }, null, 8, ["channel", "gid", "operateType"]), _ctx.channel.plat != 2 ? (_openBlock(), _createBlock(Sign, {
        key: 1,
        channel: _ctx.channel,
        gid: _ctx.gid,
        class: "marginT10"
      }, null, 8, ["channel", "gid"])) : _createCommentVNode("", true), _createVNode(TipsModal, {
        ref_key: "tipsModalRef",
        ref: tipsModalRef,
        onCancel: handleCancel,
        onOk: handleConfirm
      }, null, 512)], 64);
    };
  }
});